import { Layout, Progress } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "../../router";

//import { useTranscoding } from "../../TranscodingContext";

import "./styles.css";

import SideNav from "../SideNav";
import Dashboard from "../Dashboard";
import AddContent from "../AddContent";
import ManageArtists from "../ManageArtists";
import ManageMediaHouses from "../ManageMediaHouses";
import ManagePlans from "../ManagePlans";
import ManangeMovies from "../ManageMovies";
import ManageGenres from "../ManageGenres";
import ManageUsers from "../ManageUsers";
import ManageSeries from "../ManageSeries";
import ManageEpisodes from "../ManageEpisodes";
import ManageOrders from "../ManageOrders";
import ManageAlbums from "../ManageAlbums";
import ManageSongs from "../ManageSongs";
import ManageBanners from "../ManageBanners";
import ManagePlaylists from "../ManagePlaylists";
import ManageVPlaylists from "../ManageVPlaylists";
import ManageDiscounts from "../ManageDiscounts";
import ManageLanguages from "../ManageLanguages";
import ManageEmployees from "../ManageEmployees";
import ManagePartners from "../ManagePartners";
import ManagePermissions from "../ManagePermissions";
import ManageTickets from "../ManageTickets";
import UploadContent from "../UploadContent";
import SubMonitor from "../Reports/subscripitonMonitor";
import UserReports from "../Reports/userReports";
import ContentReports from "../Reports/contentReports";
import ChurnReports from "../Reports/churnReports";
import LikeReports from "../Reports/likeReports";
import ManageVseries from "../ManageVseries";
import ManageVEpisodes from "../ManageVEpisodes";
//import UserJourneyReports from "../Reports/UserJourneyReports";
//import RegistrationToSubscriptionPage from "../../pages/RegistrationToSubscriptionPage";
//import UserJourneyPage from "../../pages/UserJourneyPage";
//import UserMandateJourneyPage from "../../pages/UserMandateJourneyPage";
//import AvgContentEpisodePerUser from "../../pages/AvgContentEpisodePerUser";
import ReelsRoutes from "../../routes/reelsRoutes";
import SeriesCoins from "../ManageTasks/SeriesCoins";
import EpisodeCoins from "../ManageTasks/EpisodeCoins";
import UnlockConfig from "../ManageTasks/UnlockConfig";
import WatchEarnConfig from "../ManageTasks/WatchEarnConfig";
import AppConfig from "../AppConfig";
import AppConfigJson from "../AppConfigJson";
import HowItWorks from "../ManageTasks/HowItWorks";
import WatchLadderConfig from "../ManageTasks/WatchLadderConfig";
import WatchCampaignConfig from "../ManageTasks/WatchCampaignConfig";
import EpisodeRewardsConfig from "../ManageTasks/EpisodeRewardsConfig";
import QuizConfig from "../ManageTasks/QuizConfig";
import LoginIntegrityTab from "../ManageTasks/QuizConfig/LoginIntegrityTab";
import PubScaleAds from "../PubScaleAds";
import VcommissionOffers from "../VcommissionOffers";


const { Header, Content } = Layout;

/** Tab key for Upload Content (vertical shorts transcoding lives here). */
const TRANSCODING_TAB = "upload-content";

const AdminModule = ({ userEmail, initialTab }) => {
  const [selectedTab, setSelectedTab] = useState(initialTab);
//  const { job } = useTranscoding();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (initialTab === "manage-reels" && location.pathname === "/") {
      navigate("/reels", { replace: true });
    }
  }, [initialTab, location.pathname, navigate]);

  const navTo = (tab) => {
    sessionStorage.setItem("unpublished", "yes");
    navigate("/");
    setSelectedTab(tab);
  };

  const content = {
    "add-content": <AddContent />,
    "upload-content": <UploadContent />,
    dashboard: <Dashboard navTo={navTo} />,
    "manage-artists": <ManageArtists />,
    "manage-media-houses": <ManageMediaHouses />,
    "manage-plans": <ManagePlans />,
    "manage-movies": <ManangeMovies />,
    "manage-genres": <ManageGenres />,
    "manage-users": <ManageUsers />,
    "manage-series": <ManageSeries />,
    "manage-vseries": <ManageVseries />,
    "manage-vepisodes": <ManageVEpisodes />,
    "manage-episodes": <ManageEpisodes />,
    "manage-orders": <ManageOrders />,
    "manage-albums": <ManageAlbums />,
    "manage-songs": <ManageSongs />,
    banners: <ManageBanners />,
    playlists: <ManagePlaylists />,
    Vplaylists: <ManageVPlaylists />,
    "manage-discounts": <ManageDiscounts />,
    "manage-languages": <ManageLanguages />,
    "manage-employees": <ManageEmployees />,
    "manage-permissions": <ManagePermissions />,
    "manage-tickets": <ManageTickets />,
    "manage-partners": <ManagePartners />,
    "subscription-monitor": <SubMonitor />,
    "user-reports": <UserReports />,
    "content-reports": <ContentReports />,
    "churn-reports": <ChurnReports />,
    "like-reports": <LikeReports />,
    // "user-journey-reports-test": <UserJourneyReports />,
    // "registration-to-subscription-reports": <RegistrationToSubscriptionPage />,
    // "user-journey-reports": <UserJourneyPage />,
    // "user-manadate-journey-reports": <UserMandateJourneyPage />,
    // "avg_content-episode-per-user": <AvgContentEpisodePerUser />,
    "manage-reels": <Navigate to="/reels" replace />,
    "series-coins": <SeriesCoins />,
    "episode-coins": <EpisodeCoins />,
    "unlock-config": <UnlockConfig />,
    "watch-earn-config": <WatchEarnConfig />,
    "watch-ladder-config": <WatchLadderConfig />,
    "watch-campaign-config": <WatchCampaignConfig />,
    "episode-rewards-config": <EpisodeRewardsConfig />,
    "quiz-config": <QuizConfig />,
    "quiz-app-config": <QuizConfig bankValue="reasoning" />,
    "quiz-app-math": <QuizConfig bankValue="math" />,
    "login-integrity": <LoginIntegrityTab />,
    "app-config": <AppConfig />,
    "app-config-json": <AppConfigJson />,
    "tasks-how-it-works": <HowItWorks />,
    "pubscale-ads": <PubScaleAds />,
    "vcommission-offers": <VcommissionOffers />,

  };

  const logout = async () => {
    await sessionStorage.removeItem("access_token");
    await sessionStorage.removeItem("superadmin");
    await sessionStorage.removeItem("user_email");
    await sessionStorage.removeItem("lastNav");
    window.location.reload();
  };

  const updateTab = (tab) => {
    sessionStorage.removeItem("unpublished");
    setSelectedTab(tab);
    sessionStorage.setItem("lastNav", tab);
  };

  //const jobStatusUpper = String(job?.status || "").toUpperCase();
  //const showGlobalTranscodeProgress =
  //  Boolean(job?.jobId) &&
  //  selectedTab !== TRANSCODING_TAB &&
  //  (jobStatusUpper === "RUNNING" || jobStatusUpper === "QUEUED");
  //const transcodePercent =
  //  typeof job?.progress === "number" && Number.isFinite(job.progress)
  //   ? Math.max(0, Math.min(100, job.progress))
  //    : 0;

  //const seriesTitle =
  //  job?.contentTitle != null && String(job.contentTitle).trim() !== ""
  //    ? String(job.contentTitle).trim()
  //    : null;

  return (
    <>
      <Layout className="admin-shell-root">
        <Header style={{ position: "fixed", zIndex: 1, width: "100%" }}>
          <div className="header-content">
            <img
              src="/images/minipixlogo.svg"
              alt="aao-logo"
              className="header-logo"
            />
            {/* {showGlobalTranscodeProgress ? (
              <button
                type="button"
                className="global-progress"
                onClick={() => {
                  navigate("/");
                  updateTab(TRANSCODING_TAB);
                }}
                title="Open Upload Content — vertical transcoding"
              >
                <span className="global-progress-label">
                  {seriesTitle ? (
                    <>
                      <span className="global-progress-series" title={seriesTitle}>
                        {seriesTitle}
                      </span>
                      <span className="global-progress-sep"> — </span>
                    </>
                  ) : null}
                  <span> Transcoding ... </span>
                </span>
                <Progress percent={transcodePercent} size="small" showInfo />
              </button>
            ) : null}
            <span className="header-toolbar-spacer" aria-hidden />*/  }
            <div className="header-user">
              <div className="header-avatar" aria-hidden>
                {(userEmail || "?").charAt(0).toUpperCase()}
              </div>
              <div className="header-user-meta">
                <span className="header-user-caption">Signed in as</span>
                <span className="header-user-email" title={userEmail}>
                  {userEmail}
                </span>
              </div>
              <button
                type="button"
                className="header-logout"
                onClick={async () => await logout()}
              >
                <LogoutOutlined />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </Header>
        <Layout className="site-layout">
          <SideNav updateTab={updateTab} />
          <Content className="site-main-content">
            {location.pathname.startsWith("/reels") ? (
              <ReelsRoutes />
            ) : (
              content[selectedTab] ||
              "You do not have permissions to view this module"
            )}
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default AdminModule;
